import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  ConjurSecretListField,
  ConjurSecretListFieldSchemaSpec,
} from './ConjurSecretListField';

export const ConjurSecretListFieldExtension = FormFieldBlueprint.make({
  name: 'ConjurSecretList',
  params: {
    field: async () =>
      createFormField({
        name: 'ConjurSecretList',
        component: ConjurSecretListField,
        schema: ConjurSecretListFieldSchemaSpec,
      }),
  },
});
